import { render, staticRenderFns } from "./patrolDetail.vue?vue&type=template&id=21f08700&scoped=true&"
import script from "./patrolDetail.vue?vue&type=script&lang=js&"
export * from "./patrolDetail.vue?vue&type=script&lang=js&"
import style0 from "./patrolDetail.vue?vue&type=style&index=0&id=21f08700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f08700",
  null
  
)

export default component.exports